
import * as api from '../api';
import { Model, Expand } from '../common';

import { Membership } from './Membership';
import { UserAuthToken } from './UserAuthToken';

export class NotAuthorized extends Error {
    constructor() {
        super("Not authorized");
    }
}

@Model('User')
export class User extends api.ApiUser {


    @Expand()
    membership : Membership;
    assumed : boolean;

    static ROOT_URL = '/users';

    resetPassword(existingPassword : string, newPassword : string) {
        return User
            .inject(api.UsersApi)
            .resetMyPassword({
                existing_password: existingPassword,
                new_password: newPassword
            })
            .toPromise()
            .catch(e => {
                throw e.json();
            })
        ;
    }

    get avatarStyleUrl() {
        // TODO: must be updated for TYT2.1
        return null;
    }

    /**
     * Request a password reset email
     * @param email 
     */
    static requestPasswordReset(email : string): Promise<void> {
        return this.inject(api.UsersApi)
            .requestPasswordReset({
                email
            })
            .toPromise()
            .then(() => {})
            .catch(e => {
                throw e.json();
            })
        ;
    }

    /**
     * Reset the user's password using the given reset token.
     * @param token 
     * @param password 
     */
    static resetPassword(token : string, password : string): Promise<UserAuthToken> {
        return <any>this.inject(api.UsersApi)
            .resetPassword({
                token, password
            })
            .toPromise()
            .catch(e => {
                throw e.json();
            })
        ;
    }

    /**
     * Send a confirmation email
     * @param email 
     */
    static sendConfirmationMail(emailOrUserId : string | number): Promise<void> {
        return this.inject(api.UsersApi)
            .sendConfirmationEmail({
                email: <any>emailOrUserId
            })
            .toPromise()
            .then(() => {})
            .catch(e => {
                throw e.json();
            })
        ;
    }

    static assume() : Promise<UserAuthToken> {
        return <any>this.inject(api.UsersApi)
            .assume()
            .toPromise()
            .catch(e => {
                throw e.json();
            })
        ;
    }

    /**
     * Confirm an account with the given confirmation token
     * @param token 
     */
    static confirmAccount(token : string): Promise<UserAuthToken> {
        // TODO: verify update to TYT2.1
        return <any>this.inject(api.UsersApi)
            .confirmEmail({
                token
            })
            .toPromise()
            .catch(e => {
                throw e.json();
            })
        ;
    }

    /**
     * Sign in with a password
     * @param emailAddress 
     * @param password 
     */
    static signInWithPassword(emailAddress : string, password : string, rememberMe : boolean = false): Promise<UserAuthToken> {
        return <any>this
            .inject(api.UsersApi)
            .authenticate({
                method: 'tyt',
                email: emailAddress,
                password: password,
                rememberMe
            })
            .toPromise() 
            .catch((e) => {
                if (e.status == 401 || e.status == 400)
                    throw e.json();
                throw e;
            })
        ;
    }

    /**
     * Sign in with an OAuth provider.
     * @param provider 
     */
    static signInWithProvider(provider : string) {
        return this
            .inject(api.UsersApi)
            .authenticate({
                method: provider
            }) 
            .toPromise()
            .then((result : any) => location.assign(result.url))
            .catch(response => { throw response.json(); })
        ;
    }
}